/* Lightweight, dependency-free reveal engine. CSS owns the animation; this
   file only adds .is-in as content approaches the viewport. */
(function () {
  var M = (window.MofuMotion = window.MofuMotion || {});
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer;

  M.reduceMotion = reduceMotion;
  M.isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  M.enabled = false;
  M._resolved = true;
  M.ready = function () {
    /* Legacy section timelines deliberately stay disabled. Subtle CSS reveals
       and hover states replace the much heavier GSAP/ScrollTrigger bundle. */
  };

  function revealAll(scope) {
    (scope || document).querySelectorAll('.mofu-section [data-mofu-reveal]:not(.is-in)')
      .forEach(function (el) { el.classList.add('is-in'); });
  }

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.mofu-section [data-mofu-reveal]:not(.is-in)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll(scope);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }

    els.forEach(function (el, index) {
      /* A short capped stagger keeps related content feeling intentional
         without delaying navigation or making long pages feel sluggish. */
      el.style.setProperty('--mofu-reveal-delay', Math.min(index % 4, 3) * 55 + 'ms');
      if (el.getBoundingClientRect().top < window.innerHeight * 0.94) {
        el.classList.add('is-in');
      } else {
        observer.observe(el);
      }
    });
  }

  function boot() {
    observe(document);
    document.addEventListener('shopify:section:load', function (event) {
      observe(event.target);
    });
    /* Content must never remain hidden if a browser pauses observers. Keep
       this as a true safety net rather than completing every animation before
       a customer has had time to reach the section. */
    window.setTimeout(function () { revealAll(document); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
